import { useMemo, useState, useEffect } from 'react';
import { useResourceDefinitions } from 'react-admin';
import { useLocation } from 'react-router-dom';

const useController = () => {
  const location = useLocation();
  const resources = useResourceDefinitions();
  const resourceArray = Object.keys(resources)?.map((name) => ({ name, ...resources[name] }));

  const currentPath = useMemo(() => location?.pathname, [location?.pathname]);

  const [showResources, setShowResources] = useState(false);

  // Delay the rendering of the resources so styles are properly applied
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowResources(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return {
    resourceArray,
    currentPath,
    showResources,
  };
};

export default useController;
